import { Observable } from 'rxjs';
import { SubSink } from 'subsink';
import { AppNotification } from 'src/app/shared';
import { Component, Input, OnInit } from '@angular/core';
import { JalaliDateCalculatorService } from 'ngx-persian';
import { digitsEnToFa } from '@persian-tools/persian-tools';
import { NotificationService } from 'src/app/feature/services';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core';

@Component({
  selector: 'app-notification-area',
  templateUrl: './notification-area.component.html',
  styleUrls: ['./notification-area.component.sass'],
})
export class NotificationAreaComponent implements OnInit {
  @Input('notifications') notifications!: AppNotification[];

  private subsink = new SubSink();
  private markAsSeenProcessController = false;

  constructor(
    private notificationService: NotificationService,
    private authService: AuthService,
    private jalaliDate: JalaliDateCalculatorService,
    private router: Router
  ) {
    this.subsink.sink = this.authService.userProfile.subscribe({
      next: (user) => {
        if (user && user.id) {
          this.getNotifications();
        }
      },
    });
    this.subsink.sink = this.notificationService
      .notificationsSubject$()
      .subscribe((notifications) => {
        this.notifications = notifications;
      });
  }

  getNotifications() {
    this.subsink.sink = this.notificationService
      .getNotifications$()
      .subscribe((notifications) => {
        this.notifications = notifications;
      });
  }
  ngOnInit(): void {}

  public markAllAsSeen() {
    if (this.notifications.length && this.markAsSeenProcessController) {
      return;
    }

    const unseen = this.getUnseenNotifications();
    const unseenIds = unseen.map((filter) => filter.id);

    this.subsink.sink = this.notificationService
      .markAsSeen({ ids: unseenIds })
      .subscribe();
    this.markAsSeenProcessController = true;
  }

  /**
   * Depending on typeof notification run needed functionality
   */
  runFunctionality(notification: AppNotification) {
    if (notification.notificationObject.payment) {
      debugger;
      this.router.navigate([
        `user/my-orders/detailed/${notification.notificationObject.payment.factorNumber}`,
      ]);
    }

    this.subsink.sink = this.notificationService
      .markAsSeen({ ids: [notification.id] })
      .subscribe((notifications) => {
        this.notifications = notifications;
      });
  }

  public get notifications$(): Observable<AppNotification[]> {
    return this.notificationService.notificationsSubject$();
  }

  public getUnseenNotifications() {
    return this.notifications.filter((filter) => !filter.seen);
  }

  convertDateToJa(date: any) {
    const jDate = this.jalaliDate.convertToJalali(new Date(date));
    const jDateString = `${jDate.year}/${++jDate.month}/${jDate.day}`;
    return digitsEnToFa(jDateString);
  }
}
